<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
    <span>位置：</span>
    <ul class="placeul">
        <li><a href="#">首页</a></li>
        <li><a href="#">手机流量</a></li>
        <li><a href="#">手机流量查询</a></li>
        <li><a href="#">手机流量记录明细</a></li>
    </ul>
    </div>
    
    <div class="formbody">
    
    
    <div id="usual1" class="usual"> 
 
  	<div class="formbody">
    
    <table class="tablelist">
    	<thead>
    	<tr>
            <th>订单号</th>
            <th>充值时间</th>
            <th>充值号码</th>
            <th>流量包大小</th>
            <th>费用</th>
            <th>状态</th>
        </tr>
        </thead>
        <tbody>
        
            <tr v-for="item in logRechargeDetailList">
                <td>{{item.srcNo}}</td>
                <td>{{item.c_Time}}</td>
                <td>{{item.destPhone}}</td>
                <td>{{item.packageSize}}</td>
                <td>{{item.totalFee}}</td>
                <td>
                    <ol v-if="item.isState == 0">未处理</ol>
                    <ol v-else-if="item.isState == 1"><ol v-if="item.stat==0">已处理，未提交</ol><ol v-else>失败,{{item.stat}}</ol></ol> 
                    <ol v-else-if="item.isState == 2"><ol v-if="item.stat==0">提交成功</ol><ol v-else>失败,{{item.stat}}</ol></ol> 
                    <ol v-else-if="item.isState == 3"><ol v-if="item.stat==0">充值成功</ol><ol v-else>失败,{{item.stat}}</ol></ol> 
                </td>
            </tr> 
        
        
        </tbody>
    </table>
   
    <div class="pagin">
    	<el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[50]"
            :page-size="50"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </div>
    
    <div class="jian">&nbsp;</div>
  
    </div> 
    </div>
  	
	</div> 
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            midNo:this.$route.query.midNo,
            logRechargeDetailList:[],
            lldx:'',
            pageIndex:0,
            totalCount:0,
        }
    },
    mounted(){
        this.pageChange(1);
    },
    methods:{
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex){
            var that = this
            let data = {'pageIndex':pageIndex,'pageSize':50, 'midNo':this.midNo}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/llrecharge/llrechargedetail.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.logRechargeDetailList = res.data.logRechargeDetailList
                    that.pageIndex = parseInt(pageIndex)
                    that.totalCount = res.data.page.totalCount
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        rechargedetail(midNo){
            // console.log(midNo);
            location.href = "/llrechargedetail?midNo=" + midNo;
        }
    }
    
}
</script>



// WEBPACK FOOTER //
// src/components/liuliang/llrechargedetail.vue